<div class="paddle-nuber-input-container">
  <mat-form-field>
    <mat-label translate="SHARED.PADDLE_NUMBER.PADDLE_NUMBER"> </mat-label>
    <input matInput [formControl]="control" type="number" #input />
  </mat-form-field>

  @if (!control.disabled) {
    <div class="footer-container">
      @if (!!control.hasError('max')) {
        <mat-error>
          {{ 'SHARED.FORMS.ERROR.MAX' | translate: { max: control.getError('max').max } }}
        </mat-error>
      }
      @if (!!control.hasError('min')) {
        <mat-error>
          {{ 'SHARED.FORMS.ERROR.MIN' | translate: { min: control.getError('min').min } }}
        </mat-error>
      }

      @if (loaded$ | async) {
        @if (showPaddleAvailableMessage()) {
          @if (!!control.hasError('paddleNumberInUse')) {
            <mat-error translate="SHARED.PADDLE_NUMBER.PADDLE_TAKEN"> </mat-error>
          } @else {
            <div class="paddle-available-message">
              <mat-icon class="material-symbols-outline">check_circle</mat-icon>
              <span translate="SHARED.PADDLE_NUMBER.PADDLE_AVAILABLE"></span>
            </div>
          }
        } @else {
          <div></div>
        }
      } @else {
        <mat-spinner [diameter]="15"></mat-spinner>
      }

      <span (click)="autoSelect()" class="link" translate="SHARED.PADDLE_NUMBER.AUTO_SELECT_PADDLE_NUMBER"></span>
    </div>
  } @else {
    <gb-callout>
      <p [translate]="getCalloutMessage(!!(requirePaymentMethod$ | async))"></p>
    </gb-callout>
  }
</div>
